function SocialLinks({ type }) {
  return (
    <div className={`social-links-${type}`}>
      <a
        href="https://www.facebook.com/theboneheadsmusic"
        className="social-link"
        id="facebook-link"
      >
        <i className="fab fa-facebook-square" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://www.instagram.com/theboneheads/"
        className="social-link"
        id="instagram-link"
      >
        <i className="fab fa-instagram" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://www.twitter.com/theboneheadsto/"
        className="social-link"
        id="twitter-link"
      >
        <i className="fab fa-twitter" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://www.tiktok.com/@theboneheadsmusic"
        className="social-link"
        id="tiktok-link"
      >
        <i className="fab fa-tiktok" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://www.youtube.com/@theboneheadsmusic"
        className="social-link"
        id="youtube-link"
      >
        <i className="fab fa-youtube" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://open.spotify.com/artist/7zW3zPvRMV1ZGj3UYkImSZ"
        className="social-link"
        id="spotify-link"
      >
        <i className="fab fa-spotify" style={{ fontSize: "22px" }}></i>
      </a>
      <a
        href="https://music.amazon.ca/artists/B087WJ6VBS/the-boneheads"
        className="social-link"
        id="amazon-link"
      >
        <i className="fab fa-amazon" style={{ fontSize: "22px" }}></i>
      </a>
    </div>
  );
}

export default SocialLinks;
